import type { KeyboardEvent, MouseEvent, PropsWithChildren } from 'react'
import React from 'react'
import EllipsisItem from './EllipsisItem'
import PageItem from './PageItem'
import type {
  PaginationColor,
  PaginationSize,
  PaginationVariant,
} from './Pagination'

interface PageListProps {
  boundaryCount: number
  count: number
  color: PaginationColor
  disabled: boolean
  onClick: (event: MouseEvent | KeyboardEvent) => void
  page: number
  siblingCount: number
  size: PaginationSize
  variant: PaginationVariant
}

function PageList({
  boundaryCount,
  count,
  color,
  disabled,
  page,
  onClick,
  siblingCount,
  size,
  variant,
}: PropsWithChildren<PageListProps>): JSX.Element {
  const pageList = []
  const numBoundaryDisplay = 2 * siblingCount + boundaryCount + 2
  const ellipseLeft = page - 1 - siblingCount - boundaryCount >= 2
  const ellipseRight = count - page - siblingCount - boundaryCount >= 2
  const showAllPages = count - numBoundaryDisplay - boundaryCount < 2

  if (showAllPages) {
    for (let index = 1; index <= count; index++) {
      pageList.push(
        <PageItem
          color={color}
          disabled={disabled}
          index={index}
          key={`coconut-pagination-${index}`}
          onClick={onClick}
          page={page}
          size={size}
          variant={variant}
        />,
      )
    }
  } else {
    if (ellipseLeft) {
      for (let index = 1; index <= boundaryCount; index++) {
        pageList.push(
          <PageItem
            color={color}
            disabled={disabled}
            index={index}
            key={`coconut-pagination-${index}`}
            onClick={onClick}
            page={page}
            size={size}
            variant={variant}
          />,
        )
      }
      pageList.push(
        <EllipsisItem
          disabled={disabled}
          key="coconut-pagination-ellipsis-left"
          size={size}
        />,
      )
    } else {
      for (let index = 1; index <= numBoundaryDisplay; index++) {
        pageList.push(
          <PageItem
            color={color}
            disabled={disabled}
            index={index}
            key={`coconut-pagination-${index}`}
            onClick={onClick}
            page={page}
            size={size}
            variant={variant}
          />,
        )
      }
    }

    if (ellipseLeft && ellipseRight) {
      for (
        let index = page - siblingCount;
        index <= page + siblingCount;
        index++
      ) {
        pageList.push(
          <PageItem
            color={color}
            disabled={disabled}
            index={index}
            key={`coconut-pagination-${index}`}
            onClick={onClick}
            page={page}
            size={size}
            variant={variant}
          />,
        )
      }
    }

    if (ellipseRight) {
      pageList.push(
        <EllipsisItem
          disabled={disabled}
          key="coconut-pagination-ellipsis-right"
          size={size}
        />,
      )
      for (let index = count + 1 - boundaryCount; index <= count; index++) {
        pageList.push(
          <PageItem
            color={color}
            disabled={disabled}
            index={index}
            key={`coconut-pagination-${index}`}
            onClick={onClick}
            page={page}
            size={size}
            variant={variant}
          />,
        )
      }
    } else {
      for (
        let index = count + 1 - numBoundaryDisplay;
        index <= count;
        index++
      ) {
        pageList.push(
          <PageItem
            color={color}
            disabled={disabled}
            index={index}
            key={`coconut-pagination-${index}`}
            onClick={onClick}
            page={page}
            size={size}
            variant={variant}
          />,
        )
      }
    }
  }

  return <> {pageList} </>
}

export default PageList
